<mat-toolbar class="subtitulo">Unidade</mat-toolbar>

<div class="painel-principal" style="padding: 10px;">

    <mat-horizontal-stepper #stepper style="background: transparent; padding: 10px">

        <!-- DADOS BÁSICOS -->
        <mat-step [stepControl]="formCadastroDadosBasicos">
            <form #formCadastroDadosBasicos="ngForm" state="dadosBasicos">
                <ng-template matStepLabel>DADOS DO BÁSICO</ng-template>
                <dados-basicos-unidade [unidade]=unidade></dados-basicos-unidade>
                
                <div dir="rtl" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px" fxFlexFill>
                    <button mat-mini-fab name="botaoConfirmar" color="primary" matStepperNext>
                        <mat-icon>chevron_right</mat-icon>
                    </button>
                </div>
            </form>
        </mat-step>

        <!-- ESTRUTURA -->
        <mat-step [stepControl]="formCadastroEstrutura">
            <form #formCadastroEstrutura="ngForm" matStepperIcon="phone">
                <ng-template matStepLabel>ESTRUTURA</ng-template>
                <estrutura-unidade [listaEstruturaUnidade]=unidade.estruturasUnidades></estrutura-unidade>
                
                <div dir="rtl" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px" fxFlexFill>
                    <button mat-mini-fab name="botaoConfirmar" color="primary" matStepperPrevious>
                        <mat-icon>chevron_left</mat-icon>
                    </button>
                    <button mat-mini-fab name="botaoConfirmar" color="primary" matStepperNext>
                        <mat-icon>chevron_right</mat-icon>
                    </button>
                </div>
            </form>
        </mat-step>
       
        <!-- CERTIFICADOS -->
        <mat-step [stepControl]="formCertificados">
            <form #formCertificados="ngForm" matStepperIcon="phone">
                <ng-template matStepLabel>CERTIFICADOS</ng-template>
                <div ngModelGroup="certificados">
                    <certificado-unidade [listaCertificadoUnidade]=unidade.certificadosUnidade></certificado-unidade>
                </div>    
                
                <div dir="rtl" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px" fxFlexFill>
                    <button mat-mini-fab name="botaoConfirmar" color="primary" matStepperPrevious>
                        <mat-icon>chevron_left</mat-icon>
                    </button>
                </div>
            </form>
        </mat-step>


    </mat-horizontal-stepper>

    <!-- BOTOES -->
    <div dir="rtl" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px" fxFlexFill>
        <button *ngIf="!isAtualizar && mostrarBotaoCadastrar" [disabled]="formCadastroDadosBasicos.invalid || formCertificados.invalid"
            mat-raised-button name="botaoConfirmar" fxFlex="20%" color="primary" (click)="cadastrar()">
            Cadastrar
        </button>

        <button *ngIf="isAtualizar && mostrarBotaoAtualizar" [disabled]="formCadastroDadosBasicos.invalid"
            mat-raised-button name="botaoConfirmar" fxFlex="20%" color="primary" (click)="atualizar()">
            Atualizar
        </button>

        <button *ngIf="mostrarBotaoLimpar()" mat-raised-button fxFlex="20%" (click)="limpar()">
            Limpar
        </button>
        <button mat-raised-button fxFlex="20%" (click)="cancelar()">
            Cancelar
        </button>

    </div>
</div>